<template>
  <DatePicker
    v-model="date"
    :disabled="disabled"
    :clearable="clearable"
    :size="size"
    :start-placeholder="startPlaceholder"
    :end-placeholder="endPlaceholder"
    type="daterange"
    :range-separator="rangeSeparator"
    :picker-options="pickerOptions"
    @change="handleChange"
  />
</template>

<script>
import { DatePicker } from 'element-ui';
import moment from 'moment';

import shortcuts from './shortcuts';

export default {
  components: {
    DatePicker,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'large',
    },

    startPlaceholder: {
      type: String,
      default: '开始日期',
    },

    endPlaceholder: {
      type: String,
      default: '结束日期',
    },

    rangeSeparator: {
      type: String,
      default: '-',
    },

    disabledDate: {
      type: Function,
      default(time) {
        return (
          time.getTime() >= moment().subtract(0, 'day').valueOf()
        );
      },
    },
  },

  data() {
    return {
      date: this.value,
      // 记录第一个选择的日期
      firstSelectedDate: null,
      // 动态配置对象
      dynamicPickerOptions: {
        disabledDate: this.disabledDate
      },
      
      // pickerOptions: {
      //   disabledDate: this.disabledDate,
      //   shortcuts: this.getShortCuts(),
      // },
    };
  },

  computed: {
    pickerOptions() {
      return {
        // 初始禁用规则
        disabledDate: this.disabledDate,
        // 监听选择事件
        onPick: this.handleDatePick,
        // 合并动态配置
        ...this.dynamicPickerOptions,
        // 快捷选项
        shortcuts: this.getShortCuts(),
      };
    }
  },

  watch: {
    value(newVal) {
      this.date = newVal;
    },
  },

  methods: {
    isOver7Days(date) {
      return Math.abs(Date.now() - new Date(date)) > 7 * 24 * 60 * 60 * 1000;
    },
    isOver1Days(date) {
      return Math.abs(Date.now() - new Date(date)) > 1 * 24 * 60 * 60 * 1000;
    },
    // 处理日期选择事件
    handleDatePick({ maxDate, minDate }) {
      if (minDate && !maxDate) {
        // 选择了第一个日期，记录并动态更新禁用规则
        this.firstSelectedDate = minDate;
        this.updateEndDateDisabledRule(minDate);
      } else if (!minDate && !maxDate) {
        // 清空选择，重置规则
        this.firstSelectedDate = null;
        this.resetDisabledRule();
      }
    },
    
    // 更新结束日期的禁用规则
    updateEndDateDisabledRule(startDate) {
      // 创建新的禁用规则
      this.dynamicPickerOptions.disabledDate = (time) => {
        // 获取标准化的时间
        const start = new Date(startDate);
        const current = new Date(time);

        const _now = moment(new Date()).format('YYYY-MM-DD');
        const _start = moment(start).format('YYYY-MM-DD');

        if(_now == _start){
          return  time.getTime() <= moment().subtract(1, 'day').valueOf() || time.getTime() >= moment().subtract(0, 'day').valueOf()
        } else {
          const _isOver7Days = this.isOver1Days(startDate);
          if(_isOver7Days){
           return time.getTime() >= moment().subtract(1, 'day').valueOf()
          } else {
            return time.getTime() >= moment().subtract(0, 'day').valueOf()
          }
        }
      };
      
      // 强制更新（重要！）
      this.$forceUpdate();
    },
    
    // 重置禁用规则
    resetDisabledRule() {
      this.dynamicPickerOptions.disabledDate = this.disabledDate;
      this.$forceUpdate();
    },

    getShortCuts() {
      const arr = [];
      // eslint-disable-next-line guard-for-in
      for (let key in shortcuts) {
        const date = shortcuts[key];
        const shortcut = {
          text: date.text,
          onClick(picker) {
            picker.$emit('pick', date.data);
          },
        };
        arr.push(shortcut);
      }
      return arr;
    },

    handleChange() {
      this.firstSelectedDate = null;
      this.resetDisabledRule();

      const [startDate, endDate] = this.date;
      this.$emit('change', [moment(startDate), moment(endDate)]);
    },
  },
};
</script>

<style>
  .in-range:not([class*="-date"]) > div{
      background: #1890ff!important;
      border-radius: 4px!important;
      color: #fff!important;
      margin: 0px 4px;
  }
</style>
